module.exports = __webpack_public_path__ + "img/thank1.bcbde23d.svg";